import React, {forwardRef, KeyboardEvent, useEffect, useImperativeHandle, useRef, useState} from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as ClearImg } from "../../assets/icons/x.svg";
import Keyboard from "../Keyboard";
import { observer } from "mobx-react";
import { cutScannerData } from "../../helpers/orderHelper";

export interface EnterBarCodeProps {
    checkArticle: (value: string) => boolean;
}

export interface EnterBarCodeHandle {
    resetValue: () => void;
}

const EnterBarCode = forwardRef<EnterBarCodeHandle, EnterBarCodeProps>(({checkArticle}, ref) => {
    const [t] = useTranslation();
    const inputRef = useRef(null);
    const clearRef = useRef(null);

    let timer: NodeJS.Timeout;

    useImperativeHandle(ref, () => ({
        resetValue
    }), []);

    const [value, setValue] = useState<string>("");

    useEffect(() => {
        timer = setInterval(() => {
            setFocusToInput();
        }, 500);
        setFocusToInput();

        return () => {
            clearInterval(timer);
        }
    }, []);

    const setFocusToInput = () => {
        if (inputRef.current) {
            const input = inputRef.current as unknown as HTMLInputElement;
            input.focus();
        }
    }

    const onChangeTextInput = (text: string) => {
        onChangeText(text);
    }

    const onChangeText = (text: string) => {
        text = cutScannerData(text);
        setValue(text);
    }

    const keyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter")
            check();
    }

    const check = () => {
        if (value.trim().length) {
            if (checkArticle(value))
                setValue("");
        }
    }

    const resetValue = () => {
        setValue("");
    }

    return <div className="EnterBarCode">
        <div className="title">{t('enterBarCode')}</div>
        <div className="description">{t('enterBarCodeDescription')}</div>
        <div className="inputContainer">
            <div className="input">{value}</div>
            <ClearImg ref={clearRef} className="clear"/>
        </div>
        <input ref={inputRef} className="inputHide" type="text" value={value} onChange={(e) => onChangeTextInput(e.target.value)} onKeyDown={keyDown} />
        <Keyboard clearRef={clearRef} onChangeText={onChangeText} text={value} />

        <br/>
        <div className="button dark" onClick={check}>{t("search")}</div>
    </div>
})

EnterBarCode.displayName = 'EnterBarCode';

export default observer(EnterBarCode);
